import { dateDayWeeksBefore } from 'utils/dates';

const dataStrength = [
  {
    investorType: 'Venture Capital',
    strength: 'Growth perspective',
    count: 1,
    date: dateDayWeeksBefore(5, 5)
  },

  {
    investorType: 'Mutual Fund',
    strength: 'Growth perspective',
    count: 1,
    date: dateDayWeeksBefore(4, 1)
  },
  {
    investorType: 'Mutual Fund',
    strength: 'Technology',
    count: 2,
    date: dateDayWeeksBefore(4, 1)
  },
  {
    investorType: 'Mutual Fund',
    strength: 'Market positioning',
    count: 1,
    date: dateDayWeeksBefore(4, 1)
  },
  {
    investorType: 'Venture Capital',
    strength: 'Management',
    count: 1,
    date: dateDayWeeksBefore(4, 1)
  },
  {
    investorType: 'Venture Capital',
    strength: 'Technology',
    count: 1,
    date: dateDayWeeksBefore(4, 1)
  },

  {
    investorType: 'Venture Capital',
    strength: 'Management',
    count: 1,
    date: dateDayWeeksBefore(4, 5)
  },
  {
    investorType: 'Venture Capital',
    strength: 'Technology',
    count: 1,
    date: dateDayWeeksBefore(4, 5)
  },
  {
    investorType: 'Venture Capital',
    strength: 'Market positioning',
    count: 1,
    date: dateDayWeeksBefore(4, 5)
  },

  {
    investorType: 'Venture Capital',
    strength: 'Growth perspective',
    count: 1,
    date: dateDayWeeksBefore(3, 1)
  },
  {
    investorType: 'PE',
    strength: 'Growth perspective',
    count: 1,
    date: dateDayWeeksBefore(3, 1)
  },
  {
    investorType: 'PE',
    strength: 'Market positioning',
    count: 1,
    date: dateDayWeeksBefore(3, 1)
  },
  {
    investorType: 'PE',
    strength: 'Other',
    count: 1,
    date: dateDayWeeksBefore(3, 1)
  },
  {
    investorType: 'Pension Fund',
    strength: 'Growth perspective',
    count: 1,
    date: dateDayWeeksBefore(3, 1)
  },
  {
    investorType: 'Pension Fund',
    strength: 'Management',
    count: 1,
    date: dateDayWeeksBefore(3, 1)
  },
  {
    investorType: 'Pension Fund',
    strength: 'Technology',
    count: 5,
    date: dateDayWeeksBefore(3, 1)
  },
  {
    investorType: 'Pension Fund',
    strength: 'Market positioning',
    count: 5,
    date: dateDayWeeksBefore(3, 1)
  },

  {
    investorType: 'Venture Capital',
    strength: 'Management',
    count: 1,
    date: dateDayWeeksBefore(3, 2)
  },
  {
    investorType: 'Venture Capital',
    strength: 'Market positioning',
    count: 2,
    date: dateDayWeeksBefore(3, 2)
  },
  {
    investorType: 'PE',
    strength: 'Other',
    count: 1,
    date: dateDayWeeksBefore(3, 2)
  },
  {
    investorType: 'PE',
    strength: 'Market positioning',
    count: 1,
    date: dateDayWeeksBefore(3, 2)
  },

  {
    investorType: 'SWF',
    strength: 'Market positioning',
    count: 1,
    date: dateDayWeeksBefore(3, 5)
  },
  {
    investorType: 'SWF',
    strength: 'Other',
    count: 1,
    date: dateDayWeeksBefore(3, 5)
  },
  {
    investorType: 'PE',
    strength: 'Other',
    count: 1,
    date: dateDayWeeksBefore(3, 5)
  },

  {
    investorType: 'Mutual Fund',
    strength: 'Growth perspective',
    count: 1,
    date: dateDayWeeksBefore(2, 2)
  },
  {
    investorType: 'Mutual Fund',
    strength: 'Market positioning',
    count: 2,
    date: dateDayWeeksBefore(2, 2)
  },

  {
    investorType: 'PE',
    strength: 'Growth perspective',
    count: 1,
    date: dateDayWeeksBefore(2, 3)
  },
  {
    investorType: 'PE',
    strength: 'Technology',
    count: 1,
    date: dateDayWeeksBefore(2, 3)
  },
  {
    investorType: 'Venture Capital',
    strength: 'Technology',
    count: 1,
    date: dateDayWeeksBefore(2, 3)
  },

  {
    investorType: 'SWF',
    strength: 'Growth perspective',
    count: 1,
    date: dateDayWeeksBefore(2, 5)
  },
  {
    investorType: 'Mutual Fund',
    strength: 'Growth perspective',
    count: 1,
    date: dateDayWeeksBefore(2, 5)
  },
  {
    investorType: 'Mutual Fund',
    strength: 'Market positioning',
    count: 1,
    date: dateDayWeeksBefore(2, 5)
  },

  {
    investorType: 'Hedge Fund',
    strength: 'Growth perspective',
    count: 1,
    date: dateDayWeeksBefore(1, 3)
  },
  {
    investorType: 'Hedge Fund',
    strength: 'Technology',
    count: 1,
    date: dateDayWeeksBefore(1, 3)
  },

  {
    investorType: 'Mutual Fund',
    strength: 'Market positioning',
    count: 2,
    date: dateDayWeeksBefore(1, 4)
  },
  {
    investorType: 'Mutual Fund',
    strength: 'Management',
    count: 1,
    date: dateDayWeeksBefore(1, 4)
  },
  {
    investorType: 'Mutual Fund',
    strength: 'Growth perspective',
    count: 1,
    date: dateDayWeeksBefore(1, 4)
  },
  {
    investorType: 'Venture Capital',
    strength: 'Management',
    count: 2,
    date: dateDayWeeksBefore(1, 4)
  },
  {
    investorType: 'Venture Capital',
    strength: 'Growth perspective',
    count: 2,
    date: dateDayWeeksBefore(1, 4)
  },

  {
    investorType: 'Corporate',
    strength: 'Management',
    count: 1,
    date: dateDayWeeksBefore(1, 5)
  },
  {
    investorType: 'Corporate',
    strength: 'Growth perspective',
    count: 1,
    date: dateDayWeeksBefore(1, 5)
  },
  {
    investorType: 'Holding Company',
    strength: 'Management',
    count: 1,
    date: dateDayWeeksBefore(1, 5)
  },
  {
    investorType: 'Holding Company',
    strength: 'Growth perspective',
    count: 1,
    date: dateDayWeeksBefore(1, 5)
  },

  {
    investorType: 'Pension Fund',
    strength: 'Growth perspective',
    count: 1,
    date: dateDayWeeksBefore(0, 0)
  },
  {
    investorType: 'Corporate',
    strength: 'Management',
    count: 1,
    date: dateDayWeeksBefore(0, 0)
  },
  {
    investorType: 'Corporate',
    strength: 'Market positioning',
    count: 1,
    date: dateDayWeeksBefore(0, 0)
  }
];

export default dataStrength;
